module.exports = __webpack_public_path__ + "img/amx-13.2a4f27d0.jpg";